/**
 * Korean (KRW) mock rows for the CSV-import review mockup. Shapes mirror the
 * app's import preview rows (see web/src/screens/transactions/transaction-import/).
 */

/** @type {Array<import('../en/mock-import.js').MockImportRow>} */
export const MOCK_IMPORT_ROWS_KO = [
	{ date: '2026-07-30', type: 'Withdrawal', amount: 12000, description: '편의점', included: true, errors: [], isDuplicate: false },
	{ date: '2026-07-29', type: 'Purchase', amount: 4800, description: '커피숍', included: true, errors: [], isDuplicate: false },
	{ date: '2026-07-25', type: 'Deposit', amount: 3500000, description: '월급', included: true, errors: [], isDuplicate: false },
	{ date: '2026-07-22', type: 'Purchase', amount: 4830, description: '편의점', included: false, errors: [], isDuplicate: true, reason: 'existing' },
	{ date: '2026-07-18', type: 'Reward Earned', amount: 4200, description: '항공 보너스', included: false, errors: [], isDuplicate: true, reason: 'existing-possible' },
	{ date: '2026-07-12', type: '', amount: 20000, description: 'ATM 출금', included: false, errors: ['type'], isDuplicate: false },
];
